import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AIFS_PAGE } from '../../config/environment-config';

interface TextPart {
  text: string;
  href?: string;
}

interface MetaItem {
  label: string;
  value: string;
  href?: string;
}

@Component({
  selector: 'app-iframe-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './iframe-page.component.html',
  styleUrl: './iframe-page.component.css'
})
export class IframePageComponent implements OnInit {
  @ViewChild('aifsFrame') aifsFrame!: ElementRef<HTMLIFrameElement>;


  config = AIFS_PAGE;

  iframeUrl: SafeResourceUrl;
  infoExpanded = true;
  iframeAvailable = false;
  iframeChecked = false;

  
  

  constructor(private sanitizer: DomSanitizer) {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('/aifs/');


  }
  ngOnInit(): void {
  this.checkIframeAvailability();
}

async checkIframeAvailability(): Promise<void> {
  try {
    const response = await fetch('/aifs/', {
      method: 'GET',
      cache: 'no-store'
    });

    this.iframeAvailable = response.ok;
  } catch {
    this.iframeAvailable = false;
  } finally {
    this.iframeChecked = true;
  }
}
  toggleInfo(): void {
    this.infoExpanded = !this.infoExpanded;
  }

/*   applyIframeTheme(): void {
    const iframe = this.aifsFrame?.nativeElement;
    const doc = iframe?.contentDocument || iframe?.contentWindow?.document;

    if (!doc) {
      console.warn('Cannot access iframe document');
      return;
    }

    if (!doc.getElementById('desp-iframe-theme-link')) {
      const link = doc.createElement('link');
      link.id = 'desp-iframe-theme-link';
      link.rel = 'stylesheet';
      link.href = '/iframe-dark-theme.css';
      doc.head.appendChild(link);
    }
  } */
  applyIframeTheme(): void {
  const iframe = this.aifsFrame?.nativeElement;
  const doc = iframe?.contentDocument || iframe?.contentWindow?.document;

  if (!doc) {
    console.warn('Cannot access iframe document');
    return;
  }

  // Inject theme
  if (!doc.getElementById('desp-iframe-theme-link')) {
    const link = doc.createElement('link');
    link.id = 'desp-iframe-theme-link';
    link.rel = 'stylesheet';
    link.href = `/iframe-dark-theme.css?v=2`;
    doc.head.appendChild(link);
  }

  // Resize iframe to content height (eliminates inner scrollbar)
  const resizeIframe = () => {
    const height = doc.documentElement.scrollHeight || doc.body.scrollHeight;
    if (height > 0) {
      iframe.style.height = height + 'px';
    }
  };

  // Run once immediately, then observe DOM changes (Gradio renders dynamically)
  resizeIframe();

  const observer = new ResizeObserver(() => resizeIframe());
  observer.observe(doc.body);
}
}

